import {useState} from 'react'
import DeleteIcon from '../../../img/deleteIcon.svg'
import EditIcon from '../../../img/editIcon.svg'
import {FestiveGreetingVariant} from 'models/festiveGreeting'
import DeleteConfirmModal from 'module/activity-management/common/DeleteConfirmModal'
import AttentionModal from 'module/activity-management/common/AttentionModal'
import {useTranslation} from 'react-i18next'
import {LanguageItem} from 'models/CreatePromotion'

type Props = {
 templates: FestiveGreetingVariant[]
 setEditRow: (row: FestiveGreetingVariant | null) => void
 setShowDialog: (value: boolean) => void
 handleDelete: (row: FestiveGreetingVariant) => void
 languageMap: Record<string, LanguageItem>
}

const FestiveTemplate = ({
 templates,
 setEditRow,
 setShowDialog,
 handleDelete,
 languageMap,
}: Props) => {
 const {t} = useTranslation()
 const [showDelete, setShowDelete] = useState(false)
 const [showModal, setShowModal] = useState(false)
 const [itemToDelete, setItemToDelete] =
  useState<FestiveGreetingVariant | null>(null)

 return (
  <div className='mt-6 border border-[#D9DDE3] overflow-hidden bg-white'>
   <div className='overflow-x-auto'>
    <table className='w-full text-sm border-collapse table-fixed'>
     <colgroup>
      <col className='w-[25%]' />
      <col className='w-[55%]' />
      <col className='w-[20%]' />
     </colgroup>

     <thead>
      <tr className='bg-[#8B8F94] text-white'>
       <th className='p-4 text-left border-r border-[#BFC4CA]'>
        {t('festiveGreeting.templateTable.language')}
       </th>
       <th className='p-4 text-left border-r border-[#BFC4CA]'>
        {t('festiveGreeting.templateTable.templateText')}
       </th>
       <th className='p-4 text-center'>
        {' '}
        {t('festiveGreeting.templateTable.action')}
       </th>
      </tr>
     </thead>

     <tbody>
      {templates.map((item) => (
       <tr
        key={item.id ?? item.temp_id}
        className='border-t border-[#E3E6EA] align-top'
       >
        <td className='p-4 border-r border-[#E3E6EA] break-words'>
         {languageMap[item.language_code]?.language ??
          item.language_code}
        </td>

        <td className='p-4 border-r border-[#E3E6EA] whitespace-pre-wrap break-words leading-6 text-[#2F2F2F]'>
         {item.template_text}
        </td>

        <td className='p-4'>
         <div className='flex items-center justify-center gap-6'>
          <button
           onClick={() => {
            setItemToDelete(item)
            if (templates.length <= 1) setShowModal(true)
            else setShowDelete(true)
           }}
           className='flex items-center gap-1 text-red-600 font-medium'
          >
           <img
            src={DeleteIcon}
            alt='delete'
            className='h-4 w-4'
           />
           {t('confirmation.remove')}
          </button>

          <button
           onClick={() => {
            setEditRow(item)
            setShowDialog(true)
           }}
           className='flex items-center gap-1 text-blue-600 font-medium'
          >
           <img
            src={EditIcon}
            alt='edit'
            className='h-4 w-4'
           />
           {t('confirmation.edit')}
          </button>
         </div>
        </td>
       </tr>
      ))}
     </tbody>
    </table>
   </div>

   <div
    onClick={() => {
     setEditRow(null)
     setShowDialog(true)
    }}
    className='px-4 py-3 text-blue-600 cursor-pointer bg-[#F8FAFC] border-t border-[#E3E6EA]'
    style={{fontSize: 12}}
   >
    + {t('festiveGreeting.templateTable.addTemplate')}
   </div>

   {showDelete && (
    <DeleteConfirmModal
     onConfirm={() => {
      setShowDelete(false)
      if (!itemToDelete) return
      handleDelete(itemToDelete)
     }}
     onCancel={() => setShowDelete(false)}
     title={t('festiveGreeting.deleteFestiveTemplate')}
     description={t('modalData.deleteMessage')}
    />
   )}

   <AttentionModal
    open={showModal}
    onClose={() => setShowModal(false)}
   />
  </div>
 )
}

export default FestiveTemplate
